import { render, staticRenderFns } from "./AuctionsPerformanceDetails.vue?vue&type=template&id=d31d7d92&"
import script from "./AuctionsPerformanceDetails.vue?vue&type=script&lang=js&"
export * from "./AuctionsPerformanceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports